import { CommissionsInfo } from '../store/GeneralStore';
import { apiService } from './APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getCommissionsInfo = () => {
  return apiService.callExternalApi<CommissionsInfo>({
    url: `${API_SERVER_URL}/commissions-info`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};
